function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useOutsideClick(element, _ref) {
  var boundaries = _ref.boundaries,
      callback = _ref.callback;
  var initialClickTarget = null;

  function setInitialClickTarget(event) {
    var _a, _b;

    initialClickTarget = ((_b = (_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)) === null || _b === void 0 ? void 0 : _b[0]) || event.target;
  }

  function handleOutsideClick(event, resolveTarget) {
    if (!initialClickTarget) return;
    if (event.defaultPrevented) return;
    var target = resolveTarget(event);
    if (!target) return; // Return if the target is not present in the DOM anymore.

    if (!target.getRootNode().contains(target) || !target.isConnected) return;

    var _iterator = _createForOfIteratorHelper(boundaries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var boundary = _step.value;
        if (boundary === null) continue;
        if (boundary.contains(target)) return;
        if (event.composed && event.composedPath().includes(boundary)) return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    callback(event, target);
    initialClickTarget = null;
  }

  document.addEventListener('mousedown', setInitialClickTarget, true);
  document.addEventListener('click', function (event) {
    return handleOutsideClick(event, function () {
      return initialClickTarget;
    });
  }, true);

  function destroy() {
    initialClickTarget = null;
    document.removeEventListener('mousedown', setInitialClickTarget, true);
    document.removeEventListener('click', function (event) {
      return handleOutsideClick(event, function () {
        return initialClickTarget;
      });
    }, true);
  }

  var disconnectedCallback = element.disconnected.bind(element);
  Object.assign(element, {
    disconnected: function disconnected() {
      destroy();
      disconnectedCallback();
    }
  });
}

export { useOutsideClick as default };